let appStatusNoticeState = {
  notice: null,
  token: 0,
};

const appStatusNoticeListeners = new Set();

function emitAppStatusNoticeChange() {
  appStatusNoticeListeners.forEach((listener) => {
    try {
      listener();
    } catch {
      // Ignore listener errors to keep notice propagation stable.
    }
  });
}

export function getAppStatusNoticeSnapshot() {
  return appStatusNoticeState;
}

export function subscribeAppStatusNotice(listener) {
  if (typeof listener !== "function") {
    return () => {};
  }

  appStatusNoticeListeners.add(listener);
  return () => {
    appStatusNoticeListeners.delete(listener);
  };
}

export function dispatchAppStatusNotice(detail) {
  appStatusNoticeState = {
    notice: detail && typeof detail === "object"
      ? { ...detail }
      : null,
    token: appStatusNoticeState.token + 1,
  };
  emitAppStatusNoticeChange();

  return true;
}

export function clearAppStatusNotice() {
  return dispatchAppStatusNotice(null);
}

export function clearAppStatusNoticeBySource(source) {
  const normalizedSource = typeof source === "string" ? source.trim() : "";
  if (!normalizedSource) {
    return false;
  }

  if (appStatusNoticeState.notice?.source !== normalizedSource) {
    return false;
  }

  return clearAppStatusNotice();
}